import { makeHook } from "../../utils/makeSingleArgHook";
import { getPortfolioPlanClientUsage, url, } from "../request/getPortfolioPlanClientUsage";
const qs = {
    directUsage: false,
};
function keyMaker(portfolioPlanId, queryString) {
    return [url(portfolioPlanId, queryString)];
}
const useSleeveClientPortfolioPlanUsage = makeHook(async (id, config) => getPortfolioPlanClientUsage(id, qs, config), (id) => keyMaker(id, qs));
export default useSleeveClientPortfolioPlanUsage;
//# sourceMappingURL=useSleeveClientPortfolioPlanUsage.js.map